import router from '@/router'
import config from '../config/index'
let filters = [
    // 登录拦截
    function(response) {
        if (response.data && response.data.status && response.data.status == 2) {
            let _href = new RegExp('/login')
            let reg = /share/;
            if (!reg.test(window.location.hash)&& _href.test(window.location.href)) {
                router.replace('/login')
            } else if (!reg.test(window.location.hash)&& !_href.test(window.location.href)){ //登录拦截跳sso
                var xmlhttp=new XMLHttpRequest();
                let _url = 'front/sso/login'
                var url=config.serverRoot + _url;
                var type="GET";//方法
                xmlhttp.open(type,url,true);//方法，接口，异步
                xmlhttp.send();//发送请求
                xmlhttp.onreadystatechange=function(){
                if(xmlhttp.status==200&&xmlhttp.readyState==4){
                    window.location.href = xmlhttp.responseURL
                } else {
                    router.replace('/login')
                }
                }
            }
        }
        return response;
    }
]

let filterFun = function(response) {
    let result = response;
    for (let index = 0; index < filters.length; index++) {
        const filter = filters[index];
        result = filter(response);
        if (result == null) {
            return result;
        }
    }
    return result;
}


export default filterFun;


// WEBPACK FOOTER //
// ./src/filtres/index.js